import { render, staticRenderFns } from "./FooterAccordion.vue?vue&type=template&id=407e4592&scoped=true&"
import script from "./FooterAccordion.vue?vue&type=script&lang=js&"
export * from "./FooterAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FooterAccordion.vue?vue&type=style&index=0&id=407e4592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e4592",
  null
  
)

export default component.exports